import { renderless, api } from "@opentiny/vue-renderless/dropdown-menu/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import DropdownItem from "@opentiny/vue-dropdown-item";
import "@opentiny/vue-theme/dropdown-menu/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  components: {
    TinyDropdownItem: DropdownItem
  },
  emits: ["mouseenter", "mouseleave"],
  props: [].concat(props, ["visibleArrow", "arrowOffset", "placement", "popperClass", "popperAppendToBody", "textField", "options"]),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", {
    attrs: {
      "name": "tiny-zoom-in-top"
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c("ul", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.showPopper,
      expression: "state.showPopper"
    }],
    staticClass: "tiny-dropdown-menu tiny-popper",
    class: [_vm.state.size && "tiny-dropdown-menu--" + _vm.state.size, _vm.popperClass],
    on: {
      "mouseenter": _vm.handleMouseenter,
      "mouseleave": _vm.handleMouseleave
    }
  }, [_vm._t("default", function() {
    return _vm._l(_vm.options, function(item, index) {
      return _c("tiny-dropdown-item", {
        key: index,
        attrs: {
          "itemData": item,
          "label": item[_vm.textField],
          "icon": item.icon,
          "disabled": item.disabled,
          "divided": item.divided,
          "tip": item.tip,
          "tip-position": item.tipPosition
        }
      });
    });
  })], 2)]);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
